import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  snackbarOpen: false,
  snackbarType: 'success',
  snackbarMessage: '',

  bulkSnackbarOpen: false,
  bulkSnackbarType: 'success',
  bulkSnackbarMessage: ' ',
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setSnackbar: (state, { payload }) => {
      return {
        snackbarOpen: payload.snackbarOpen,
        snackbarType: payload.snackbarType,
        snackbarMessage: payload.snackbarMessage, //? User Either can specifify the message
      };
    },
    setBulkSnackbar: (state, { payload }) => {
      return {
        bulkSnackbarOpen: payload.bulkSnackbarOpen,
        bulkSnackbarType: payload.bulkSnackbarType,
        bulkSnackbarMessage: payload.bulkSnackbarMessage, //? User Either can specifify the message
      };
    },
  },
});

const { reducer, actions } = snackbarSlice;
export const { setSnackbar, setBulkSnackbar } = actions;
export default reducer;
